import view from "../../views/news.js";
import KTAPI from "../api/index.api.js";
import { KTLang } from "../lang/lang.js";
import { _handler, storage } from "../classes/index.classes";
import { router, toggleLoader } from "../router/index.routes";
import { msgDialog, welcomeDialog } from "./offscreen.controller.js";
import { renderBadgeUnreadNews, renderNew as menuRenderNew } from "./header.controller.js";

const removeHtmlTags = str => str.replace(/<[^>]*>|&lt;[^&gt;]*&gt;/g, '');
const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);

const bgColors = {announcement: 'light-primary', new: 'light-info', event: 'light-danger', update: 'light-success'};

var loading = false;

var newListSkeleton = /*html*/`<div class="card-body skeleton-loader-news">
    <div class="row">
        <!-- Image link -->
        <div class="col-12 col-sm-6 d-flex mb-6 mb-sm-0">
            <div class="skeleton-loader-news-image"></div>
        </div>
        <!-- Text content -->
        <div class="col-12 col-sm-6 d-flex flex-column justify-content-center">
            <div class="d-inline-block">
                <div class="skeleton-loader-news-badge"></div>
            </div>
            <!-- Title link -->
            <div class="skeleton-loader-news-title"></div>
            <!-- Description -->
            <div class="skeleton-loader-news-description"></div>
            <!-- Additional information -->
            <div class="d-flex gap-5 mw-100 mt-8">
                <div class="d-flex align-items-center w-100 flex-grow-1">
                    <div class="symbol symbol-35px me-3 rounded overflow-hidden skeleton-loader-news-avatar"></div>
                    <div class="d-flex justify-content-start flex-column w-100">
                        <div class="d-flex align-items-center">
                            <div class="skeleton-loader-news-author"></div>
                        </div>
                        <div class="d-flex">
                            <div class="skeleton-loader-news-timestamp"></div>
                            <span class="mx-3">·</span>
                            <div class="skeleton-loader-news-date"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

`;

let cl = {
    render: (info) => {
        return info ? '' : view;
    },
    after_render: async (info) => {

        if(info)
        {                        
            renderNewExtensive(info);
            console.log(info);
        }
        else
        {
            renderSkeleton(true);
            await toggleLoader(".news-list");

            $(".news-sec-header").removeClass("d-none");
            KTLang.update();
            $(".news-list").data("news-page",1);
            let page = 1;
            loading = false;

            
            
            let res = await KTAPI.getNews({page, limit: 10});
            //alert("oi" );
            //console.log(res);
            
            renderNewsList(res);
            $("#news-loader").addClass("d-none");            
                        
            KTScroll.init();

            //welcomeDialog(function(){alert("accepted")}, function(){alert("rejected")} );

            
        }
        
    },
    root: false, 
    rerender: true,
    where: '#kt_content'
};

async function renderSkeleton(show)
{
    if(show)
    {
        $(".news-list").append(newListSkeleton);
        //$(".news-list").append(newListSkeleton);
    }
    else
    {        
        $(".skeleton-loader-news").remove();        
    }
}

async function renderNewsList(res)
{
    renderSkeleton(false);
    const lang = KTLang.getLang();
    
    let html = [];    
    if(res.message == 'error') return;    
    
    res.news.docs.map(pl => {
        html.push(renderNew(pl));
    });

    await toggleLoader(".news-list");

    $(".news-list").append(html);
    router.updatePageLinks();

    function renderNew(data)
    {
        let titles = ``;
        let descriptions = ``;
        let contents = ``;
        let images = ``;

        Object.keys(data.translations).map(key => {
            titles+=`<span class="news-lang ${lang == key ? '' : 'd-none'} teko-header text-uppercase fs-1 lh-0" lang="${key}">${data.translations[key].title}</span>`;
            descriptions+=`<span class="news-lang ${lang == key ? '' : 'd-none'}" lang="${key}">${data.translations[key].description}</span>`;
            contents+=`<span class="news-lang ${lang == key ? '' : 'd-none'}" lang="${key}">${removeHtmlTags(data.translations[key].content)}</span>`;
            images+=`<img src="${data.translations[key].image}" alt="new-image" class="img-fluid rounded news-lang ${lang == key ? '' : 'd-none'}" lang="${key}" style="max-height: 275px; width: 100%;" />`;

        });

        let htm = /*html*/`
        <div class="card-body">
            <div class="row">
                <!-- Image link -->
                <div class="col-12 col-sm-6 d-flex mb-6 mb-sm-0">
                    <a class="align-self-center" data-navigo href="news/${data.slug}">
                        ${images}
                    </a>
                </div>
                <!-- Text content -->
                <div class="col-12 col-sm-6 d-flex flex-column justify-content-center">
                    <div class="d-inline-block">
                        <span class="badge badge-${bgColors[data.category]} fw-bold my-2 text-uppercase" data-i18n="news.${data.category}">${data.category}</span>
                    </div>
                    <!-- Title link -->                                
                    <a href="news/${data.slug}" data-navigo class="fw-bold text-gray-900 mb-4 fs-3 fs-lg-2 fs-xl-1 lh-base text-hover-primary overflow-hidden" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">${titles}</a>
                    <!-- Description -->
                    <div class="text-gray-600 fs-7 fs-md-6 mt-1 overflow-hidden" style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">${contents}</div>
                    <!-- Additional information -->
                    <div class="d-flex gap-5 mw-100 mt-8">
                        <div class="d-flex align-items-center">
                            <div class="symbol symbol-35px me-3 rounded overflow-hidden">
                                <span class="symbol-label bg-light">
                                    <img src="${data.author_avatar}" class="h-100 align-self-end" alt="author's avatar">
                                </span>
                            </div>
                            
                            <div class="d-flex justify-content-start flex-column">
                                <div class="d-flex align-items-center"><a href="user/${data.author_community}" data-navigo class="text-gray-800 fw-bold text-hover-primary fs-6">${data.author}</a></div>
                                <div class="d-flex">
                                    <span class="text-gray-700 text-start fw-semibold text-muted text-hover-info d-block fs-7" data-i18n="example.dated" data-i18n-options='{"timestamp":"${parseInt(data.createdAt)+hostStampDif}"}'></span>
                                    <span class="mx-3">·</span>
                                    <span class="text-gray-700 text-start fw-semibold text-muted text-hover-info d-block fs-7" data-i18n="example.blog" data-i18n-options='{"timestamp":"${parseInt(data.createdAt)+hostStampDif}"}'></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                        
        </div>`;
        htm = $(htm);
        htm.localize();
        htm.find("[data-i18n-options]").text(function(i, text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        });
        return htm;
    }


    
}

async function renderNewExtensive(data)
{
    if(data.message == 'error') return;
    const lang = KTLang.getLang();    

    data = data.news;

    let titles = ``;
    let descriptions = ``;
    let contents = ``;
    let images  = ``;

    Object.keys(data.translations).map(key => {

        titles+=`<span class="news-lang ${lang == key ? '' : 'd-none'} teko-header text-uppercase lh-0 fs-3x" lang="${key}">${data.translations[key].title}</span>`;
        descriptions+=`<span class="news-lang ${lang == key ? '' : 'd-none'}" lang="${key}">${data.translations[key].description}</span>`;
        contents+=`<div class="news-lang ${lang == key ? '' : 'd-none'}" lang="${key}">${data.translations[key].content}</div>`;
        images+=`<img src="${data.translations[key].image}" alt="new-image" class="img-fluid rounded news-lang ${lang == key ? '' : 'd-none'}" lang="${key}" style="max-height: auto; width: 100%;" />`;
    });


    $("#kt_content").html(/*html*/`
        <div id="kt_content_container" class="container-xxl">
            <div class="d-flex justify-content-center">
                <div class="min-w-0 w-100 mx-4" style="max-width:675px">
                    <div>
                        <span class="badge badge-${bgColors[data.category]} fw-bold my-2 text-uppercase" data-i18n="news.${data.category}">${data.category}</span>
                    
                        <h1 class="text-gray-900 fw-bolder mb-10 fs-2hx">${titles}</h1>
                    

                        <div>
                            <div class="d-flex justify-content-between">
                                <div class="d-block w-100">
                                    <div class="d-flex align-items-center">
                                        
                                        <div class="symbol symbol-35px me-3 rounded overflow-hidden">
                                            <span class="symbol-label bg-light">
                                                <img src="${data.author_avatar}" class="h-100 align-self-end" alt="author's avatar">
                                            </span>
                                        </div>
                                        
                                        <div class="d-flex justify-content-start flex-column">
                                            <div class="d-flex align-items-center"><a href="user/${data.author_community}" data-navigo class="text-gray-800 fw-bold text-hover-primary fs-6">${data.author}</a></div>
                                            <div class="d-flex">
                                                <span class="text-gray-700 text-start fw-semibold text-muted text-hover-info d-block fs-7" data-i18n="example.dated" data-i18n-options='{"timestamp":"${parseInt(data.createdAt)+hostStampDif}"}'></span>
                                                <span class="mx-3">·</span>
                                                <span class="text-gray-700 text-start fw-semibold text-muted text-hover-info d-block fs-7" data-i18n="example.blog" data-i18n-options='{"timestamp":"${parseInt(data.createdAt)+hostStampDif}"}'></span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="d-flex align-items-center"><span class="badge badge-lg badge-light"><i class="fad fa-eye me-2 text-gray-800"></i> ${data.views}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-10 mr-auto ml-auto clearfix">
                        ${images}
                    </div>
                    <div class="mt-16 fs-5 fw-semibold text-gray-700">
                        ${contents}
                    </div>
                </div>
            </div>
        </div>
    `);

    $("#kt_content").localize();
    $("#kt_content").find("[data-i18n-options]").text(function(i, text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    });

    let newsRead = storage.get('newsRead') || [];    
    if(!newsRead.includes(data._id))
    {
        newsRead.push(data._id);
        storage.set('newsRead', newsRead);
        renderBadgeUnreadNews('remove', data._id);
        menuRenderNew(data, false, true);
    }
    
}


_handler.on('lang-changed', async (lng) =>{

});


$(document).ready(function(){
    $(document).on('click', '.btn-lang', function() {    
        $(".news-lang").addClass("d-none");        
        $(".news-lang[lang='"+$(this).attr("data-lang").substring(0,2)+"']").removeClass("d-none");        
    });
});



  

export default cl;